module.exports = __webpack_public_path__ + "static/media/ren_left3d546b6e9d5273f5c7f229b558289e46.webp";